import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { ECOMMERCE_FETCH_STORES, ECOMMERCE_FETCH_OBJECTS, ECOMMERCE_FETCH_OBJECT, ECOMMERCE_CLEAR_OBJECTS_CACHE, ECOMMERCE_SAVE_OBJECT_CACHE } from 'ContentData/actions/ActionTypes';
import * as ecommerceClient from 'ContentData/api/Ecommerce';
import { fetchCrmObject } from 'ContentData/api/CrmObjects';
import { getObjectCache } from 'ContentData/selectors/ecommerce';
import { ECOMMERCE_OBJECT_LABEL_PROPERTIES, ECOMMERCE_OBJECT_TYPE_IDS } from '../constants/ecommerce';
const fetchStoresAction = createGenericFetchAction(ECOMMERCE_FETCH_STORES, ecommerceClient.fetchStores, undefined, true);
export const fetchStores = () => fetchStoresAction();
const fetchObjectsAction = createGenericFetchAction(ECOMMERCE_FETCH_OBJECTS, ecommerceClient.fetchObjects, undefined, true);
export const fetchObjects = query => {
  return fetchObjectsAction(query);
};
const fetchObjectAction = createGenericFetchAction(ECOMMERCE_FETCH_OBJECT, fetchCrmObject, undefined, true);
export const fetchObject = (objectType, objectId) => {
  const labelProperty = ECOMMERCE_OBJECT_LABEL_PROPERTIES[objectType];
  return fetchObjectAction({
    objectTypeId: ECOMMERCE_OBJECT_TYPE_IDS[objectType],
    objectType,
    id: objectId,
    query: {
      properties: [labelProperty]
    }
  });
};
export const saveObjectCache = (objectType, objectId) => {
  return (dispatch, getState) => {
    const object = getObjectCache(getState(), {
      objectType,
      objectId
    });
    dispatch({
      type: ECOMMERCE_SAVE_OBJECT_CACHE,
      objectType,
      object
    });
  };
};
export const clearObjectsCache = objectType => {
  return {
    type: ECOMMERCE_CLEAR_OBJECTS_CACHE,
    objectType
  };
};